module.exports = __webpack_public_path__ + "static/media/breakfast.08448717.svg";